<template>
    <div class="user_page">
        <div class="top_change">
            <div class="l_where">
                系统设置<span>/</span>用户管理
            </div>
            <div class="middle_width flex-b">
                <div v-if="!($store.state.identity == 3 && $store.state.auth.indexOf('user-deputy-admin') == -1)">
                    <div class="nav_name" v-if="userInfo.role == 2" :class="storePrams.type === '1' ? 'active' : ''"
                        @click="changeTable('1')">管理员</div>
                </div>
                <div class="nav_name" :class="storePrams.type === '2' ? 'active' : ''" @click="changeTable('2')">普通用户
                </div>
            </div>
            <div class="r_back" @click="goBack">
                <i class="iconfont icon-fanhui"></i>
            </div>
        </div>
        <div class="table_card">
            <div class="top_search flex">
                <Input v-model="storePrams.phone" placeholder="请输入姓名、电话、进行搜索" style="width: 300px" />
                <Button @click="searchList" style="margin-left:12px" type="primary">查询</Button>
            </div>
            <Button type="primary" @click="creatUser" style="margin-top:16px" v-if="storePrams.type === '1'">创建</Button>
            <Table :columns="columnTable" :loading="loading" :data="dataTable" style="margin-top: 20px">
                <template slot-scope="{row}" slot="operation">
                    <div class="flex-c" style="display: flex;flex-wrap: wrap;">
                        <!-- v-if="userInfo.is_template_component == 1"  -->
                        <div class="table-btn blue new-table-btn mb-1" v-if="showMoban" @click="goTemplate(row)">模板组件</div>
                        <div class="table-btn blue new-table-btn mb-1" @click="goMove(row)">合同转移</div>
                        <div class="table-btn del new-table-btn mb-1"  @click="cancelIt(row)">解除</div>
                        <div class="table-btn edit new-table-btn mb-1" @click="editInfo(row,'编辑管理员')">编辑</div>
                        <div class="table-btn danger new-table-btn mb-1" @click="delThis(row)">删除</div>
                        <div class="table-btn danger new-table-btn mb-1" v-if="is_sass_admin" @click="delRubbish(row)">废弃文件
                        </div>
                    </div>
                </template>
                <template slot-scope="{row}" slot="login_time">
                    {{ row.login_time ? row.login_time : '--' }} | {{ row.login_port_type == 1 ? 'PC' : row.login_port_type == 2 ? '小程序' : '-' }}
                </template>
                <template slot-scope="{row}" slot="operations">
                    <div class="flex-c">
                        <div class="table-btn del" @click="cancelIt(row)">解除</div>
                        <div class="table-btn edit new-table-btn" @click="editInfo(row,'编辑用户')">编辑</div>
                        <div class="table-btn danger" @click="delThis(row)">删除</div>
                        <div class="table-btn danger new-table-btn" v-if="is_sass_admin" @click="delRubbish(row)">废弃文件
                        </div>
                    </div>
                </template>
                <template slot-scope="{index}" slot="index">
                    <div class="flex-c">
                        {{ index + 1 }}
                    </div>
                </template>
                <template slot-scope="{row}" slot="tell">
                    <div class="note_style" @click="cancelIt(row)">{{ row.openid ? '已绑定' : '未绑定' }}</div>
                </template>
                <template slot-scope="{row}" slot="note">
                    <div class="note_style" @click="changeNote(row)">{{ row.sms_num }}</div>
                </template>
                <template slot-scope="{row}" slot="qrcode"> 
                    <div class="note_style" @click="changeQrcode(row)">{{ row.qrcode_num }}</div>
                </template>
                <template slot-scope="{row}" slot="number">
                    <div class="note_style" @click="changeContract(row)">{{ row.contract_num }}</div>
                </template>
                <template slot-scope="{row}" slot="integral">
                    <div class="note_style" @click="changeIntegral(row)">
                        {{ row.ai_token_num || 0 }}
                    </div>
                </template>
            </Table>
            <Page :total="storePrams.total" :current="storePrams.page" style="text-align:right;margin-top: 20px"
                show-elevator show-total @on-change="pageChange" :page-size="storePrams.limit" />
        </div>
        <!--  二维码修改次数-->
        <div class="show_table" v-if="needQrcodeTable">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">二维码次数配置</div>
                <div class="t-c" @click="needQrcodeTable = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="nav_switch">
                        <div class="label" style="margin-right: 16px">二维码次数配置</div>
                        <i-switch v-model="messageForm.qrcode_switch" :true-value="1" :false-value="0" size="large"
                            @on-change="closeQrcode">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                    <div v-if="messageForm.qrcode_switch === 1">
                        <div class="flex">
                            <div class="btn flex-c" @click="needQrcodeMsg = true">变动二维码数量</div>
                            <div class="last">当前剩余：{{ messageForm.qrcode_num }}条</div>
                        </div>
                        <Table :columns="columnMsg" :loading="loadingC" :data="dataQrcodeMsg" style="margin-top: 20px"> 
                            <template slot-scope="{index}" slot="idx">
                                <div class="flex-c">{{ index + 1 }}</div>
                            </template>
                        </Table>
                        <Page :total="morePrams.total" :current="morePrams.page"
                            style="text-align:right;margin-top: 20px" show-elevator show-total
                            @on-change="pageQrcodeChange" :page-size="morePrams.limit" />
                    </div>
                </div> 
            </div>
        </div>
        
        <div class="show_change" v-if="needQrcodeMsg">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">二维码次数配置</div>
                <div class="t-c" @click="needQrcodeMsg = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="input_nav flex">
                        <div class="label">二维码数量</div>
                        <div class="val">
                            <Input v-model="messageForm.qrcode_num" type="number" placeholder="请输入二维码数量" />
                        </div>
                    </div>
                </div>
                <div class="give">
                    <div class="cancel flex-c" @click="needQrcodeMsg = false">取 消</div>
                    <div class="require flex-c" @click="resetQrcodeNum">确 定</div>
                </div>
            </div>
        </div>
        <!--  短信修改次数-->
        <div class="show_table" v-if="needTable">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">短信次数配置</div>
                <div class="t-c" @click="needTable = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="nav_switch">
                        <div class="label" style="margin-right: 16px">短信次数配置</div>
                        <i-switch v-model="messageForm.sms_switch" :true-value="1" :false-value="0" size="large"
                            @on-change="closeSms">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                    <div v-if="messageForm.sms_switch === 1">
                        <div class="flex">
                            <div class="btn flex-c" @click="needMsg = true">变动短信</div>
                            <div class="last">当前剩余：{{ messageForm.sms_num }}条</div>
                        </div>
                        <Table :columns="columnMsg" :loading="loadingA" :data="dataMsg" style="margin-top: 20px">
                            <template slot-scope="{index}" slot="idx">
                                <div class="flex-c">
                                    {{ index + 1 }}
                                </div>
                            </template>
                        </Table>
                        <Page :total="morePrams.total" :current="morePrams.page"
                            style="text-align:right;margin-top: 20px" show-elevator show-total
                            @on-change="pageSmsChange" :page-size="morePrams.limit" />
                    </div>
                </div>
            </div>
        </div>
        <div class="show_change" v-if="needMsg">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">短信次数配置</div>
                <div class="t-c" @click="needMsg = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="input_nav flex">
                        <div class="label">短信数量</div>
                        <div class="val">
                            <Input v-model="messageForm.sms_num" type="number" placeholder="请输入短信数量" />
                        </div>
                    </div>
                </div>
                <div class="give">
                    <div class="cancel flex-c" @click="needMsg = false">取 消</div>
                    <div class="require flex-c" @click="resetNum">确 定</div>
                </div>
            </div>
        </div>
        <!--  积分修改次数-->
        <div class="show_table" v-if="needIntegralTable">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">积分次数配置</div>
                <div class="t-c" @click="needIntegralTable = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="nav_switch">
                        <div class="label" style="margin-right: 16px">积分次数配置</div>
                        <i-switch v-model="messageForm.ai_token_switch" :true-value="1" :false-value="0" size="large"
                            @on-change="closeIntegral">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                    <div v-if="messageForm.ai_token_switch === 1">
                        <div class="flex">
                            <div class="btn flex-c" @click="needIntegralMsg = true">变动积分</div>
                            <div class="last">当前剩余：{{ messageForm.ai_token_num }}条</div>
                        </div>
                        <Table :columns="columnMsg" :loading="loadingD" :data="dataIntegralMsg" style="margin-top: 20px">
                            <template slot-scope="{index}" slot="idx">
                                <div class="flex-c">
                                    {{ index + 1 }}
                                </div>
                            </template>
                        </Table>
                        <Page :total="morePrams.total" :current="morePrams.page"
                            style="text-align:right;margin-top: 20px" show-elevator show-total
                            @on-change="pageIntegralChange" :page-size="morePrams.limit" />
                    </div>
                </div>
            </div>
        </div>
        <div class="show_change" v-if="needIntegralMsg">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">积分次数配置</div>
                <div class="t-c" @click="needIntegralMsg = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="input_nav flex">
                        <div class="label">积分数量</div>
                        <div class="val">
                            <Input v-model="messageForm.ai_token_num" type="number" placeholder="请输入积分数量" />
                        </div>
                    </div>
                </div>
                <div class="give">
                    <div class="cancel flex-c" @click="needIntegralMsg = false">取 消</div>
                    <div class="require flex-c" @click="resetIntegralNum">确 定</div>
                </div>
            </div>
        </div>
        <!--  合同修改次数-->
        <div class="show_table" v-if="needContractTable">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="contxq">合同次数配置</div>
                <div class="t-c" @click="needContractTable = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div style="padding:24px;padding-top:12px">
                    <div class="nav_switch">
                        <div class="label" style="margin-right: 16px">合同次数配置</div>
                        <i-switch v-model="messageForm.contract_switch" :true-value="1" :false-value="0"
                            @on-change="closeContract" size="large">
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                    <!-- v-if="messageForm.contract_switch === 1" -->
                    <div >
                        <div class="flex">
                            <div class="btn flex-c" @click="needContractMsg = true">变动合同数量</div>
                            <div class="last">当前变动剩余：{{ messageForm.contract_num }}条</div>
                            <div class="last">当前流量包充值剩余：{{ package_num }}条</div>
                        </div>
                        <Tabs value="name1" style="margin-top: 20px" @on-click="handleTabChange">
                            <TabPane label="充值" name="name1">
                                <Table :columns="columnRecharge" :loading="loadingRecharge" :data="dataRecharge"
                                    style="margin-top: 20px">
                                    <template slot-scope="{index}" slot="idx">
                                        <div class="flex-c">{{ index + 1 }}</div>
                                    </template>
                                </Table>
                                <Page :total="rechargePrams.total" :current="rechargePrams.page"
                                    style="text-align:right;margin-top: 20px" show-elevator show-total
                                    @on-change="pageRechargeChange" :page-size="rechargePrams.limit" />
                            </TabPane>
                            <TabPane label="分配" name="name2">
                                <Table :columns="columnMsg" :loading="loadingB" :data="dataContractMsg"
                                    style="margin-top: 20px">
                                    <template slot-scope="{index}" slot="idx">
                                        <div class="flex-c">{{ index + 1 }}</div>
                                    </template>
                                </Table>
                                <Page :total="morePrams.total" :current="morePrams.page"
                                    style="text-align:right;margin-top: 20px" show-elevator show-total
                                    @on-change="pageSmsChange" :page-size="morePrams.limit" />
                            </TabPane>
                        </Tabs> 
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="show_change" v-if="needContractMsg">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="t-c" @click="needContractMsg = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div class="contxq">合同数量</div>
                <div style="padding:12px 24px;">
                    <div class="input_nav flex">
                        <div class="label">合同数量</div>
                        <div class="val">
                            <Input v-model="messageForm.contract_num" type="number" placeholder="请输入合同数量" />
                        </div>
                    </div>
                </div>
                <div class="give">
                    <div class="cancel flex-c" @click="needContractMsg = false">取 消</div>
                    <div class="require flex-c" @click="resetContractNum">确 定</div>
                </div>
            </div>
        </div>
        <!--  合同转移次数 -->
        <div class="show_change" v-if="moveContract">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="t-c" @click="moveContract = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div class="contxq">合同转移</div>
                <div style="padding:24px;padding-top:12px">
                    <div class="input_nav flex">
                        <div class="label">管理员</div>
                        <div class="val">
                            <Select v-model="transferor_uid" filterable>
                                <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.real_name }}
                                </Option>
                            </Select>
                        </div>
                    </div>
                </div>

                <div class="give">
                    <div class="cancel flex-c" @click="moveContract = false">取 消</div>
                    <div class="require flex-c" @click="resetElseNum">确 定</div>
                </div>
            </div>
        </div>
        <!--  模板组件-->

        <div class="show_change" v-if="temComponents">
            <div class="pop"></div>
            <div class="pop_table fixed">
                <div class="t-c" @click="temComponents = false">
                    <Icon type="md-close" size="25" />
                </div>
                <div class="contxq">模板组件</div>
                <div style="padding:24px;padding-top:12px">
                    <div class="input_nav flex">
                        <div class="label">模板组件开关：</div>
                        <div class="nav_switch">
                            <i-switch @on-change="chooseTemp" v-model="messageForm.is_template" :true-value="1"
                                :false-value="0" size="large">
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 创建用户弹出层-->
        <modal v-if="showModal" :modalInfo="modalInfo" @giveVal="getVal" @closeModal="showModal = false"></modal>
    </div>
</template>

<script>
import modal from '@/components/modal/index'
import {
    addadministrator,
    permlist,
    getCsList,
    getConfInfo,
    setCsnum,
    uppassword,
    clean_upfiles,
    managerDelete, relieve, getUserList, contractTransfer, template_switch, get_packagelist
} from '../../../api/interFace'
export default {
    name: "user",
    components: {
        modal
    },
    data() {
        return {
            activeType: '1',
            activeNav: '1',
            showModal: false,
            needTable: false,
            moveContract: false,
            needContractTable: false,
            needQrcodeTable: false,
            needQrcodeMsg: false,
            needIntegralTable: false,
            needIntegralMsg: false,
            temComponents: false,
            needMsg: false,
            needContractMsg: false,
            contract_name: '', 
            dataQrcodeMsg: [],
            dataIntegralMsg: [],
            loadingC: false,
            loadingD: false,
            morePramsQrcode: {
                limit: 5,
                page: 1,
                total: 0,
                uid: '',
                type: ''
            },
            dataRecharge: [],
            loadingRecharge: false,
            rechargePrams: {
                limit: 15,
                page: 1,
                total: 0,
                uid: ''
            },
            columnRecharge: [
                {
                    title: '#',
                    align: 'center',
                    width: 80,
                    slot: 'idx'
                },
                {
                    title: '名称',
                    align: 'center',
                    key: 'name'
                },
                {
                    title: '总份数',
                    align: 'center',
                    key: 'copies'
                },
                {
                    title: '剩余份数',
                    align: 'center',
                    key: 'remain_num'
                },
                // {
                //     title: '开始日期',
                //     align: 'center',
                //     key: 'start_date'
                // },
                {
                    title: '到期日期',
                    align: 'center',
                    key: 'expires_date'
                },
                {
                    title: '创建时间',
                    align: 'center',
                    key: 'created_at'
                }
            ],
            modalInfo: {
                title: '创建管理员',
                inputList: [
                    {
                        label: '姓名',
                        inputType: 'text',
                        inputVal: ''
                    },
                    {
                        label: '手机号',
                        inputType: 'number',
                        inputVal: ''
                    },
                    {
                        label: '密码',
                        inputType: 'password',
                        inputVal: ''
                    }
                ]
            },
            columnTable: [
                {
                    title: '序号',
                    align: 'center',
                    width: 120,
                    slot: 'index'
                },
                {
                    title: '姓名',
                    align: 'center',
                    key: 'real_name'
                },
                {
                    title: '手机号',
                    align: 'center',
                    key: 'phone'
                },
                {
                    title: '是否绑定',
                    align: 'center',
                    slot: 'tell'
                },
                {
                    title: '短信次数',
                    align: 'center',
                    slot: 'note'
                },
                {
                    title: '二维码次数',
                    align: 'center',
                    slot: 'qrcode'
                },
                {
                    title: '合同次数',
                    align: 'center',
                    slot: 'number'
                },
                {
                    title: '积分次数',
                    align: 'center',
                    slot: 'integral'
                },
                {
                    title: '创建时间',
                    align: 'center',
                    key: 'created_at'
                },
                {
                    title: '最后登陆时间',
                    align: 'center',
                    slot: 'login_time'
                },
                {
                    title: '操作',
                    align: 'center',
                    fixed: 'right',
                    width: 300,
                    slot: 'operation'
                }
            ],
            dataTable: [],
            storePrams: {
                limit: 10,
                page: 1,
                total: 0,
                phone: '',
                type: '1'
            },
            package_num: 0,
            morePrams: {
                limit: 5,
                page: 1,
                total: 0,
                uid: '',
                type: ''
            },
            columnMsg: [
                {
                    title: '#',
                    align: 'center',
                    slot: 'idx'
                },
                {
                    title: '变动次数',
                    align: 'center',
                    key: 'num'
                },
                {
                    title: '变动时间',
                    align: 'center',
                    key: 'created_at'
                }
            ],
            dataMsg: [],
            cityList: [],
            dataContractMsg: [],
            cardMsg: '',
            administrator: {
                real_name: '',
                phone: '',
                password: '',
                role_id: '3',
                user_expire_time: '',
                id: '',
            },
            loading: false,
            loadingA: false,
            loadingB: false,
            needType: 2,
            messageForm: {
                qrcode_num: '0',
                qrcode_switch: 0,
                contract_num: '0',
                contract_switch: 0,
                sms_switch: 0,
                sms_num: '0',
                ai_token_switch: 0,
                ai_token_num: '0',
                uid: '',
                is_template: 0,
            },
            editId: '',
            transferor_uid: '',
            showMoban: false,
            userInfo: {},
            is_sass_admin: false,
        }

    },
    computed: {
        // usetype: function() { 
        //     return this.$store.state.userInfo.id
        // }    

        // add_but:function(){
        //     return (this.$store.state.identity +''+this.$store.state.auth.indexOf('user-deputy-admin') == -1)
        // }
    },
    watch: {
        // usetype: {
        //     handler: function(newVal) {
        //         console.log('usetype', newVal)
        //     },
        //     immediate: true // 立即执行一次
        // }

        // add_but:{
        //     handler: function(newVal) {
        //         console.log('add_but', newVal)
        //         console.log('需要刷新')
        //     },
        //     immediate: true // 立即执行一次
        // }
    },
    created() {
        this.$store.commit('changePollingSpin', false)
        // localStorage.setItem("is_sass_admin", data.is_sass_admin == 1 ? 1 : 0) //是否从sass 跳入 如果是 则用户管理下可以删除废弃合同ss
        this.is_sass_admin = localStorage.getItem("is_sass_admin") == 1 ? true : false
        this.userInfo = this.$store.state.userInfo;
        if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
            this.columnTable.push({
                title: '到期日期',
                align: 'center',
                key: 'user_expire_time'
            })
          
            this.showMoban = true
        } else {
            this.showMoban = false
        }
        if (this.$store.state.identity == 3 && this.$store.state.auth.indexOf('user-deputy-admin') == -1) {
            console.log('abc')
            this.changeTable('2')
            this.storePrams.type === '2'
        }
        if (this.userInfo.role == 3) {
            this.changeTable('2');
        } else {
            this.getlist()
        }
    },
    methods: {
        goBack() {
            this.$emit('goBack')
        },
        goTemplate(row) {
            this.messageForm.uid = row.id
            this.temComponents = true
            this.modifyMsg()
        },
        chooseTemp() {
            template_switch({ uid: this.messageForm.uid, status: this.messageForm.is_template }).then(res => {
                this.$Message.success(res.msg)
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        goMove(row) {
            this.messageForm.uid = row.id
            this.moveContract = true
            this.getUser()
        },
        
        resetElseNum() {
            contractTransfer({ transferor_uid: this.transferor_uid, uid: this.messageForm.uid }).then(res => {
                this.$Message.success(res.msg)
                this.moveContract = false
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        closeSms(e) {
            if (e === 0) {
                this.messageForm.sms_switch = 0
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needMsg = false
                    this.needTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            } else {
                this.messageForm.sms_switch = 1
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()

                    this.needTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            }
        },
        closeQrcode(e) {
            if (e === 0) {
                this.messageForm.qrcode_switch = 0
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needQrcodeTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            }else{
                this.messageForm.qrcode_switch = 1
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needQrcodeTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            }
        },
        closeContract(e) {
            if (e === 0) {
                this.messageForm.contract_switch = 0
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needContractMsg = false
                    this.needContractTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            } else {
                this.messageForm.contract_switch = 1
                setCsnum(this.messageForm).then(res => {
                    this.messageForm.contract_switch = 1
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needContractMsg = false
                }).catch(res => {
                    this.messageForm.contract_switch = 0
                    this.$Message.error(res.msg)
                })

            }
        },
        closeIntegral(e) {
            if (e === 0) {
                this.messageForm.ai_token_switch = 0
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needIntegralMsg = false
                    this.needIntegralTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            } else {
                this.messageForm.ai_token_switch = 1
                setCsnum(this.messageForm).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.needIntegralTable = false
                    this.resetMessageForm()
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            }
        },
        getUser() {
            getUserList({ uid: this.messageForm.uid }).then(res => {
                this.cityList = res.data
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        cancelIt(row) {
            this.$Modal.confirm({
                title: '解绑提示',
                content: '请问您是否确认解绑此条用户！！！',
                onOk: () => {
                    relieve({ id: row.id }).then(res => {
                        this.$Message.success(res.msg)
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        delRubbish(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '请问您是否确认删除该用户下垃圾文件嘛，删除后无法恢复!!!',
                onOk: () => {
                    this.loading = true
                    clean_upfiles({ uid: row.id }).then(res => {
                        this.loading = false
                        this.$Message.success(res.msg)
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        delThis(row) {
            this.$Modal.confirm({
                title: '删除提示',
                content: '请问您是否确认删除此条用户信息，删除后无法恢复!!!',
                onOk: () => {
                    managerDelete({ id: row.id }).then(res => {
                        this.$Message.success(res.msg)
                        this.getlist()
                    }).catch(res => {
                        this.$Message.error(res.msg)
                    })
                },
                onCancel: () => {
                }
            });
        },
        creatUser() {
            this.editId = ''
            this.modalInfo = {
                title: '创建管理员',
                inputList: [
                    {
                        label: '姓名',
                        inputType: 'text',
                        inputVal: ''
                    },
                    {
                        label: '手机号',
                        inputType: 'number',
                        inputVal: ''
                    },
                    {
                        label: '密码',
                        inputType: 'password',
                        inputVal: ''
                    }
                ]
            }
            if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
                this.modalInfo.inputList.push({
                    label: '到期时间',
                    inputType: 'datePicker',
                    inputVal: ''
                })
            }
            this.showModal = true
        },
        editInfo(row,editType) {
            if(editType == '编辑用户'){
                this.modalInfo = {
                title: editType,
                inputList: [
                    {
                        label: '姓名',
                        inputType: 'text',
                        inputVal: ''
                    }
                ]
            }
            }else{
                this.modalInfo = {
                title: editType,
                inputList: [
                    {
                        label: '姓名',
                        inputType: 'text',
                        inputVal: ''
                    },
                    {
                        label: '新密码',
                        inputType: 'password',
                        inputVal: ''
                    },
                    {
                        label: '重复密码',
                        inputType: 'password',
                        inputVal: ''
                    }
                ]
            }
            }
            
            this.showModal = true
            this.editId = row.id
            if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
                this.modalInfo.inputList.push({
                    label: '到期时间',
                    inputType: 'datePicker',
                    inputVal: ''
                })
                this.modalInfo.inputList[3].inputVal = row.user_expire_time || ""
            }
            this.modalInfo.inputList[0].inputVal = row.real_name
        },

        getSideTable() {
            this.loadingA = true
            this.loadingB = true
            this.loadingC = true
            this.loadingD = true
            this.morePrams.uid = this.messageForm.uid
            this.morePrams.type = this.needType
            getCsList(this.morePrams).then(res => {
                this.loadingA = false
                this.loadingB = false
                this.loadingC = false
                this.loadingD = false
                if (this.needType === 2) {
                    this.dataMsg = res.data.data
                    this.morePrams.total = res.data.total
                } else if (this.needType === 1) {
                    this.dataContractMsg = res.data.data
                    this.morePrams.total = res.data.total
                } else if (this.needType === 4) {
                    this.dataIntegralMsg = res.data.data
                    this.morePrams.total = res.data.total
                } else {
                    this.dataQrcodeMsg = res.data.data
                    this.morePrams.total = res.data.total
                }
            })
        },
        pageSmsChange(index) {
            this.morePrams.page = index
            this.getSideTable()
        },
        
        pageQrcodeChange(index) {
            this.morePrams.page = index
            this.getSideTable()
        },
        pageIntegralChange(index) {
            this.morePrams.page = index
            this.getSideTable()
        },
        changeNote(row) {
            this.needType = 2
            this.messageForm.type = 2
            this.messageForm.uid = row.id
            this.needTable = true
            this.modifyMsg()
            this.getSideTable()
        },
        changeQrcode(row) {
            this.needType = 3
            this.messageForm.type = 3
            this.messageForm.uid = row.id
            this.needQrcodeTable = true
            this.modifyMsg()
            this.getSideTable()
        },
        changeContract(row) {
            this.needType = 1
            this.messageForm.type = 1
            this.messageForm.uid = row.id 
            this.needContractTable = true
            this.modifyMsg()
            this.getSideTable()
            this.getRechargeList()
        },
        changeIntegral(row) {
            this.needType = 4
            this.messageForm.type = 4
            this.messageForm.uid = row.id
            this.needIntegralTable = true
            this.modifyMsg()
            this.getSideTable()
        },
        getRechargeList() {
            this.loadingRecharge = true
            this.rechargePrams.uid = this.messageForm.uid
            get_packagelist(this.rechargePrams).then(res => {
                // messageForm.contract_num
                this.loadingRecharge = false
                this.dataRecharge = res.data.data || []
                this.rechargePrams.total = res.data.total || 0
            }).catch(res => {
                this.loadingRecharge = false
                this.$Message.error(res.msg || '获取充值列表失败')
            })
        },
        pageRechargeChange(index) {
            this.rechargePrams.page = index
            this.getRechargeList()
        },
        handleTabChange(name) {
            if (name === 'name1') {
                // 切换到充值标签页，重新加载充值列表
                this.rechargePrams.page = 1
                this.getRechargeList()
            } else if (name === 'name2') {
                // 切换到分配标签页，重新加载分配列表
                this.morePrams.page = 1
                this.getSideTable()
            }
        },
        modifyMsg() {
            getConfInfo({ uid: this.messageForm.uid }).then(res => {
                this.messageForm.contract_num = res.data.contract_num
                this.package_num = res.data.package_num||0
                this.messageForm.contract_switch = Number(res.data.contract_switch)
                this.messageForm.sms_switch = Number(res.data.sms_switch)
                this.messageForm.is_template = Number(res.data.is_template)
                this.messageForm.sms_num = res.data.sms_num
                this.messageForm.qrcode_num = res.data.qrcode_num
                this.messageForm.qrcode_switch = Number(res.data.qrcode_switch)
                this.messageForm.ai_token_num = res.data.ai_token_num || '0'
                this.messageForm.ai_token_switch = Number(res.data.ai_token_switch || 0)
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        resetIntegralNum() {
            setCsnum(this.messageForm).then(res => {
                this.$Message.success(res.msg)
                this.getlist()
                this.needIntegralMsg = false
                this.needIntegralTable = false
                this.resetMessageForm()
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        resetContractNum() {
            setCsnum(this.messageForm).then(res => {
                this.$Message.success(res.msg)
                this.getlist()
                this.needContractMsg = false
                this.needContractTable = false
                this.resetMessageForm()
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        resetQrcodeNum() {  
            setCsnum(this.messageForm).then(res => {
                this.$Message.success(res.msg)
                this.getlist()
                this.needQrcodeMsg = false
                this.needQrcodeTable = false
                this.resetMessageForm()
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        resetNum() {
            setCsnum(this.messageForm).then(res => {
                this.$Message.success(res.msg)
                this.getlist()
                this.needMsg = false
                this.needTable = false
                this.resetMessageForm()
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },
        resetMessageForm() {
            this.messageForm = {
                contract_num: '0',
                contract_switch: 0,
                sms_switch: 0,
                sms_num: '0',
                qrcode_num: '0',
                qrcode_switch: 0,
                ai_token_switch: 0,
                ai_token_num: '0',
                uid: '',
                type: ''
            }
        },
        changeTable(type) {
            this.storePrams.type = type
            this.storePrams.page = 1
            this.getlist()
            if (type === '2') {
                this.columnTable = [
                    {
                        title: '序号',
                        align: 'center',
                        width: 120,
                        slot: 'index'
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'real_name'
                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone'
                    },
                    {
                        title: '是否绑定',
                        align: 'center',
                        slot: 'tell'
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'created_at'
                    },
                    {
                        title: '最后登陆时间',
                        align: 'center',
                        slot: 'login_time'
                    },
                    {
                        title: '操作',
                        align: 'center',
                        fixed: 'right',
                        width: 260,
                        slot: 'operations'
                    }
                ]
            } else {
                this.columnTable = [
                    {
                        title: '序号',
                        align: 'center',
                        width: 120,
                        slot: 'index'
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'real_name'
                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone'
                    },
                    {
                        title: '是否绑定',
                        align: 'center',
                        slot: 'tell'
                    },
                    {
                        title: '短信次数',
                        align: 'center',
                        slot: 'note'
                    },
                    {
                        title: '二维码次数',
                        align: 'center',
                        slot: 'qrcode'
                    },
                    {
                        title: '合同次数',
                        align: 'center',
                        slot: 'number'
                    },
                    {
                        title: '积分次数',
                        align: 'center',
                        slot: 'integral'
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'created_at'
                    },
                    {
                        title: '最后登陆时间',
                        align: 'center',
                        slot: 'login_time'
                    },
                    {
                        title: '操作',
                        align: 'center',
                        fixed: 'right',
                        width: 300,
                        slot: 'operation'
                    }
                ]
                if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
                    this.columnTable.push({
                        title: '到期日期',
                        align: 'center',
                        key: 'user_expire_time'
                    })
                }
            }
        },
        pageChange(index) {
            this.storePrams.page = index
            this.getlist()
        },
        searchList() {
            this.storePrams.page = 1
            this.getlist()
        },
        getlist() {
            this.loading = true
            permlist(this.storePrams).then(async res => {
                this.dataTable = res.data.data || []
                this.storePrams.total = res.data.total
                this.loading = false
            }).catch(res => {
                this.loading = false
                this.$Message.error(res.msg)
            })
        },
        getVal(e) {
            if (this.editId) {
                this.administrator.real_name = e[0]
                this.administrator.new_password = e[1]
                this.administrator.true_password = e[2]
                if ((this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) && !e[3]) {
                    this.$Message.error('请选择管理员到期日期')
                    return
                }
                if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
                    this.administrator.user_expire_time = e[3] || ''
                }
                this.administrator.id = this.editId
                uppassword(this.administrator).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.reset()
                    this.showModal = false
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            } else {
                this.administrator.real_name = e[0]
                this.administrator.phone = e[1]
                this.administrator.password = e[2]
                if ((this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) && !e[3]) {
                    this.$Message.error('请选择到期日期')
                }
                if (this.userInfo.uniacid_id == 6 || this.userInfo.uniacid_id == 66) {
                    this.administrator.user_expire_time = e[3] || ''
                }
                addadministrator(this.administrator).then(res => {
                    this.$Message.success(res.msg)
                    this.getlist()
                    this.reset()
                    this.showModal = false
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
            }
        },
        reset() {
            this.administrator.id = ''
            this.administrator.role_id = ''
            this.administrator.password = ''
            this.administrator.real_name = ''
            this.administrator.phone = ''
            this.administrator.user_expire_time = ''
        }
    }
}
</script>

<style scoped lang="scss">
.mb-1{
    margin-bottom:5px;
    margin-top: 5px;
}
.contxq {
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    font-weight: 500;
    color: #17233d;
    padding-left: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8eaec;
}

.user_page {
    .top_change {
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 30px;
        box-sizing: border-box;

        .l_where {
            font-size: 18px;
            font-weight: bold;
            color: #1B2742;

            span {
                color: #4877E8;
            }
        }

        .r_back {
            .iconfont {
                font-size: 26px;
                cursor: pointer;

                &:hover {
                    color: #4877E8;
                }
            }
        }

        .middle_width {
            width: 18%;
            margin: auto;
        }

        .nav_name {
            font-size: 20px;
            font-weight: bold;
            color: #545F78;
            height: 66px;
            line-height: 66px;
            cursor: pointer;
            position: relative;

            &:hover {
                color: #4877E8;
            }
        }

        .active {
            color: #4877E8;

            &:after {
                content: '';
                display: inline-block;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 2px;
                background: #4877E8;
                border-radius: 1px;
            }
        }
    }

    .new-table-btn {
        font-size: 12px
    }

    .table_card {
        width: 100%;
        min-height: 700px;
        padding: 24px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 8px;
        position: relative;
        margin-top: 20px;

        .creat {
            width: 64px;
            height: 28px;
            background: #FFFFFF;
            border: 1px solid #4877E8;
            border-radius: 6px;
            font-size: 14px;
            font-weight: bold;
            color: #4877E8;
            margin-top: 20px;
            cursor: pointer;

            &:hover {
                background: #4877E8;
                color: white;
            }
        }

        .note_style {
            height: 30px;
            line-height: 30px;
            background: #FFFFFF;
            border: 1px solid #C8CEDA;
            border-radius: 4px;
            width: fit-content;
            padding: 0 8px;
            display: inline-block;
            font-size: 16px;
            color: #545F78;
            cursor: pointer;
        }
    }

    .show_table {
        .pop_table {
            width: 700px;
            min-height: 530px;
            background: white;
            border-radius: 8px;
            box-sizing: border-box;

            .s-b {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
            }

            .t-c {
                position: absolute;
                top: 15px;
                right: 15px;
                cursor: pointer;
            }

            .btn {
                width: 120px;
                height: 34px;
                background: #FFFFFF;
                border: 1px solid #DBDEE6;
                border-radius: 6px;
                font-size: 14px;
                color: #515a6e;
                cursor: pointer;

                &:hover {
                    border-color: #4877E8;
                    color: #4877E8;
                }
            }

            .last {
                display: inline-block;
                font-size: 16px;
                color: #BDC4D2;
                margin-left: 20px;
            }

            .nav_switch {
                display: flex;
                margin-bottom: 20px;

                span {
                    font-size: 14px;
                }
            }
        }
    }

    .show_change {
        .pop {
            z-index: 9998;
        }

        .pop_table {
            z-index: 9999;
            width: 500px;
            background: white;
            border-radius: 8px;
            box-sizing: border-box;

            .t-c {
                position: absolute;
                top: 15px;
                right: 15px;
                cursor: pointer;
            }

            .give {
                display: flex;
                justify-content: right;
                margin-bottom: 12px;
                padding-right: 24px;

                .require {
                    width: 60px;
                    height: 32px;
                    background: #2d8cf0;
                    border: 1px solid #2d8cf0;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #FFFFFF;
                    cursor: pointer;

                    &:hover {
                        opacity: 0.6;
                    }
                }

                .cancel {
                    width: 60px;
                    height: 34px;
                    color: #515a6e;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 400;
                    cursor: pointer;
                    margin-right: 20px;

                    &:hover {
                        color: #4877E8;
                    }
                }
            }

            .input_nav {
                margin-bottom: 12px;

                .label {
                    font-size: 14px;
                    font-weight: 400;
                    color: #515a6e;
                    margin-right: 20px;
                }

                .val {
                    flex: 1;
                }
            }
        }
    }
}
</style>
